import React, { useEffect, useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import TextInput from "../../Global Functions/textInput";
import { Link, useNavigate, useParams } from "react-router-dom";
import SelectInput from "../../Global Functions/selectInput";
import { ReactComponent as DealsIcon } from "../../Global Icons/Deals.svg";
import InnerHeading from "../../Global Functions/innerHeading";
import { useDispatch, useSelector } from "react-redux";
import {
  addNewDeal,
  updateDeal,
  viewDeal,
} from "../../Redux/Actions/dealsAction";
import { getEnums } from "../../Redux/Actions/enumsActions";
import AddImage from "../../Global Functions/addImage";
import {
  viewCityList,
  viewStateList,
} from "../../Redux/Actions/settingsActions";
import { getProjectList } from "../../Redux/Actions/projectActions";
import ImageShowerModalGlobal from "../../Global Functions/imageShowerModalGlobal";
import toast from "react-hot-toast";
import { viewBuilderList } from "../../Redux/Actions/builderActions";
import "./DealForm.css";

const DealForm = () => {
  const [dealsData, setDealsData] = useState({
    name: "",
    image: "",
    title: "",
    builder_id: "",
    discount_type: "",
    deal_type: "",
    country_id: "",
    state: "",
    city: "",
    project_id: "",
    value: "",
    start_date: "",
    end_date: "",
    term_and_condition: "",
    is_special: false,
  });

  const [originalDealData, setOriginalDealData] = useState({});

  const { id } = useParams();
  const isEditMode = Boolean(id);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { deal } = useSelector((state) => state.deals || {});
  const { builders } = useSelector((state) => state.builders || {});
  const { enumsData } = useSelector((state) => state.enumsData || {});
  const { countryList } = useSelector((state) => state.country || {});
  const { states } = useSelector((state) => state.states || {});
  const { cities } = useSelector((state) => state.city || {});
  const { projects } = useSelector((state) => state.projects || {});

  useEffect(() => {
    if (isEditMode) {
      dispatch(viewDeal(id));
    }
  }, [id, dispatch, isEditMode]);

  useEffect(() => {
    if (isEditMode && deal?.data) {
      const d = deal.data;
      const formattedData = {
        name: d.name || "",
        image: d.image || "",
        title: d.title || "",
        builder_id: d.builder?._id || "",
        discount_type: d.discount_type || "",
        deal_type: d.deal_type || "",
        country_id: d.country || "",
        state: d.state || "",
        city: d.city || "",
        project_id: d.project?._id || "",
        value: d.value || "",
        start_date: d.start_date?.split("T")[0] || "",
        end_date: d.end_date?.split("T")[0] || "",
        term_and_condition: d.term_and_condition || "",
        is_special: d.is_special || false,
      };
      setDealsData(formattedData);
      setOriginalDealData(formattedData);
    }
  }, [deal, isEditMode]);

  useEffect(() => {
    const statusEnums = enumsData?.data?.ProjectStatus
      ? Object.values(enumsData.data.ProjectStatus)
      : [];

    if (statusEnums.length && dealsData.builder_id) {
      dispatch(
        getProjectList({
          page: 1,
          limit: 500,
          status: statusEnums,
          is_deleted: false,
          builder_id: dealsData.builder_id,
        })
      );
    }
  }, [enumsData?.data?.ProjectStatus, dealsData.builder_id, dispatch]);

  useEffect(() => {
    dispatch(getEnums());
    dispatch(viewBuilderList({ page: 1, limit: 1000, is_deleted: false }));
  }, [dispatch]);

  useEffect(() => {
    if (dealsData.country_id) {
      dispatch(
        viewStateList({
          page: 1,
          limit: 1000,
          country: dealsData.country_id,
        })
      );
    }
  }, [dealsData.country_id, dispatch]);

  useEffect(() => {
    if (dealsData.state) {
      dispatch(
        viewCityList({
          page: 1,
          limit: 1000,
          country: dealsData.country_id,
          state: dealsData.state,
        })
      );
    }
  }, [dealsData.state, dealsData.country_id, dispatch]);

  const handleAddChange = (e) => {
    const { name, type, value, checked } = e.target;
    setDealsData((prev) => {
      let updated = { ...prev, [name]: type === "checkbox" ? checked : value };

      if (
        name === "start_date" &&
        updated.end_date &&
        new Date(updated.end_date) < new Date(value)
      ) {
        updated.end_date = value;
      }
      return updated;
    });
  };

  const handleImageUpload = async (e) => {
    const uploadedFile = e.target.files[0];
    if (!uploadedFile) return;
    const responseUrl = await AddImage(uploadedFile);
    if (responseUrl) {
      setDealsData((prev) => ({ ...prev, image: responseUrl }));
    }
    e.target.value = "";
  };

  const getUpdatedFields = () => {
    const updatedFields = {};
    for (const key in dealsData) {
      if (dealsData[key] !== originalDealData[key]) {
        updatedFields[key] = dealsData[key];
      }
    }
    return updatedFields;
  };

  const isFormEmpty = () => {
    // Check essential fields or all fields as per requirement
    return (
      !dealsData.deal_type &&
      !dealsData.builder_id &&
      !dealsData.name &&
      !dealsData.start_date &&
      !dealsData.end_date &&
      !dealsData.country_id &&
      !dealsData.state &&
      !dealsData.city &&
      !dealsData.discount_type &&
      !dealsData.value &&
      !dealsData.term_and_condition &&
      !dealsData.image
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      let response;
      if (isEditMode) {
        const updatedFields = getUpdatedFields();
        if (Object.keys(updatedFields).length === 0) {
          toast("No changes detected.");
          return;
        }
        if (updatedFields.deal_type) {
          updatedFields.type = updatedFields.deal_type;
          delete updatedFields.deal_type;
        }
        const payload = {
          id,
          ...updatedFields,
        };
        response = await dispatch(updateDeal(payload));
      } else {
        const payload = { ...dealsData };
        if (payload.deal_type) {
          payload.type = payload.deal_type;
          delete payload.deal_type;
        }
        response = await dispatch(addNewDeal(payload));
      }

      if (response?.statusCode === 200) {
        toast.success(isEditMode ? "Deal Updated" : "Deal Created");
        navigate("/dealsAndOffers");
      } else {
        toast.error(response?.message || "Something went wrong");
      }
    } catch (error) {
      toast.error(error?.message || "Error occurred");
    }
  };

  const discountOptions = enumsData?.data?.DiscountType
    ? Object.values(enumsData.data.DiscountType)
    : [];

  const dealTypeOptions = enumsData?.data?.dealType
    ? Object.values(enumsData.data.dealType)
    : [];

  return (
    <MainLayout>
      <div style={{ height: "fit-content", width: "96%" }}>
        <div
          style={{
            padding: "20px",
            background: "white",
            borderRadius: "25px",
            width: "100%",
          }}
        >
          <InnerHeading
            Icon={DealsIcon}
            onClick={() => navigate("/dealsAndOffers")}
            heading={isEditMode ? "Edit Deal" : "Add Deal"}
            buttonLabel="View Deals List"
          />

          <form onSubmit={handleSubmit}>
            {/* Select Deal Type Dropdown */}
            <div style={{ marginBottom: "20px" }}>
              <SelectInput
                label="Select Deal Type"
                name="deal_type"
                value={dealsData.deal_type}
                onChange={handleAddChange}
                placeholder="Select Deal Type"
                options={
                  dealTypeOptions?.map((type) => ({
                    label: type.replace(/_/g, " "),
                    value: type,
                  })) || []
                }
              />
            </div>

            {dealsData.deal_type !== "deals" && (
              <div style={{ marginBottom: "20px" }}>
                <SelectInput
                  label="Select Builder"
                  name="builder_id"
                  value={dealsData.builder_id}
                  onChange={handleAddChange}
                  placeholder="Select Builder"
                  options={
                    builders?.data?.map((b) => ({
                      label: b.brand_name,
                      value: b._id,
                    })) || []
                  }
                />
              </div>
            )}

            {/* Conditionally show Builder and Project immediately after Deal Type */}
            {dealsData.deal_type === "deals" && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "10px",
                  marginBottom: "20px",
                }}
              >
                <div style={{ width: "50%" }}>
                  <SelectInput
                    label="Select Builder"
                    name="builder_id"
                    value={dealsData.builder_id}
                    onChange={handleAddChange}
                    placeholder="Select Builder"
                    options={
                      builders?.data?.map((b) => ({
                        label: b.brand_name,
                        value: b._id,
                      })) || []
                    }
                  />
                </div>

                <div style={{ width: "50%" }}>
                  <SelectInput
                    label="Select Project"
                    name="project_id"
                    value={dealsData.project_id}
                    onChange={handleAddChange}
                    options={
                      projects?.data?.map((p) => ({
                        label: p.project_name,
                        value: p._id,
                      })) || []
                    }
                  />
                </div>
              </div>
            )}

            {/* Always visible fields */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                gap: "10px",
              }}
            >
              <div style={{ width: "50%" }}>
                <TextInput
                  label="Start Date"
                  name="start_date"
                  type="date"
                  value={dealsData.start_date}
                  onChange={handleAddChange}
                  min={new Date().toISOString().split("T")[0]}
                  max={dealsData.end_date}
                />
                <TextInput
                  label="Deal Name"
                  name="name"
                  type="text"
                  value={dealsData.name}
                  onChange={handleAddChange}
                  placeholder="Enter Name"
                />
              </div>

              <div style={{ width: "50%" }}>
                <TextInput
                  label="End Date"
                  name="end_date"
                  type="date"
                  value={dealsData.end_date}
                  onChange={handleAddChange}
                  min={
                    dealsData.start_date ||
                    new Date().toISOString().split("T")[0]
                  }
                />
                <SelectInput
                  label="Select Country"
                  name="country_id"
                  value={dealsData.country_id}
                  onChange={handleAddChange}
                  options={
                    countryList?.data?.map((c) => ({
                      label: c.country_name,
                      value: c._id,
                    })) || []
                  }
                />
              </div>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                gap: "10px",
                marginTop: "20px",
              }}
            >
              <div style={{ width: "50%" }}>
                <SelectInput
                  label="Select State"
                  name="state"
                  value={dealsData.state}
                  onChange={handleAddChange}
                  disabled={!dealsData.country_id}
                  options={
                    states?.data?.map((s) => ({
                      label: s.state_name,
                      value: s._id,
                    })) || []
                  }
                />
                <SelectInput
                  label="Discount Type"
                  name="discount_type"
                  value={dealsData.discount_type}
                  onChange={handleAddChange}
                  options={
                    discountOptions?.map((type) => ({
                      label: type,
                      value: type,
                    })) || []
                  }
                />
              </div>

              <div style={{ width: "50%" }}>
                <SelectInput
                  label="Select City"
                  name="city"
                  value={dealsData.city}
                  onChange={handleAddChange}
                  disabled={!dealsData.state}
                  options={
                    cities?.data?.map((c) => ({
                      label: c.city_name,
                      value: c._id,
                    })) || []
                  }
                />
                <TextInput
                  label="Discount Value"
                  name="value"
                  type="number"
                  value={dealsData.value}
                  onChange={handleAddChange}
                />
                <TextInput
                  label="Terms & Condition"
                  name="term_and_condition"
                  type="text"
                  value={dealsData.term_and_condition}
                  onChange={handleAddChange}
                />
                <TextInput
                  label="is special"
                  name="is_special"
                  type="checkbox"
                  value={dealsData.is_special}
                  onChange={handleAddChange}
                />
              </div>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                gap: "10px",
                marginTop: "20px",
              }}
            >
              <div style={{ width: "50%" }}>
                <span className="span-class">Upload Deal Image</span>
                <input
                  type="file"
                  name="image"
                  id="image"
                  onChange={handleImageUpload}
                  hidden
                />
                <label className="label-class-image" htmlFor="image">
                  Click To Upload Image
                </label>
                <ImageShowerModalGlobal
                  file={dealsData.image}
                  keyField="image"
                  setState={setDealsData}
                  state={dealsData}
                />
              </div>
            </div>

            <div
              style={{
                margin: "20px auto",
                display: "flex",
                gap: "10px",
              }}
            >
              <Link to="/dealsAndOffers">
                <button type="button" className="button-class-white">
                  Cancel
                </button>
              </Link>
              <button
                type="submit"
                className={isFormEmpty() ? "button-disabled" : "button-class"}
                disabled={isFormEmpty()}
              >
                {isEditMode ? "Update" : "Save"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </MainLayout>
  );
};

export default DealForm;
